import React from "react";

/**
 * Reusable Favorites Icon Component
 * Heart SVG icon with dynamic stroke weight based on active state
 */
const FavoritesIcon = ({
  className = "w-7 h-7",
  isActive = false,
  activeFill = "none",
  ...props
}) => {
  const gradientId = `primaryGradientFavorites-${React.useId()}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${className} flex-shrink-0`}
      {...props}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFE48A" />
          <stop offset="50%" stopColor="var(--color-primary)" />
          <stop offset="100%" stopColor="#A87A1F" />
        </linearGradient>
      </defs>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={isActive ? "2" : "1.5"}
        stroke={`url(#${gradientId})`}
        fill={
          isActive
            ? activeFill === "gradient"
              ? `url(#${gradientId})`
              : activeFill === "currentColor"
                ? "currentColor"
                : "none"
            : "none"
        }
        d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
      />
    </svg>
  );
};

export default FavoritesIcon;
